import React, { Component } from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import Aux from '../../hoc/Aux';
import Menu from '../Menu/Menu';
import classes from './Layout.css';
import BGImage from '../../assets/images/bs-background.svg';
import * as menuActions from '../../actions/MenuActions';
import SideDrawer from '../../components/SideDrawer/SideDrawer';
import SocialNetworks from '../../components/SocialNetworks';

class Layout extends Component {
    state = {
        rightMenuItems: [],
        showSideDrawer: false
    };

    componentDidMount() {
        const { menu } = this.props;

        // Home
        if (this.props.pathname === '/') {
            this.setState({
                rightMenuItems: [...menu.rightMenu.items]
            });
        } else {
            // Remove Appointments and Contact from right menu if not Home
            const newRightMenuItems = [...menu.rightMenu.items];
            newRightMenuItems.splice(2, 2);
            this.setState({ rightMenuItems: newRightMenuItems });
        }
    }

    handleSideDrawerClose = () => {
        this.setState({ showSideDrawer: false });
    };

    toggleSideDrawer = event => {
        event.preventDefault();

        this.setState(prevState => {
            return {
                showSideDrawer: !prevState.showSideDrawer
            };
        });
    };

    render() {
        const { menu } = this.props;
        const { showSideDrawer } = this.state;

        return (
            <Aux>
                <img src={BGImage} className="BackgroundImage" alt="" />

                {menu.topMenu.hidden ? null : (
                    <nav className={classes.TopMenu}>
                        <Menu menuItems={menu.topMenu.items} />
                    </nav>
                )}

                {menu.leftMenu.hidden ? null : (
                    <nav className={classes.LeftMenu}>
                        <Menu menuItems={menu.leftMenu.items} />
                    </nav>
                )}

                {menu.rightMenu.hidden ? null : (
                    <nav className={classes.RightMenu}>
                        <Menu menuItems={this.state.rightMenuItems} />
                    </nav>
                )}

                {/* Tailor-Made Collections Menu */}
                {menu.tailormadeMenu.hidden ? null : (
                    <nav className={classes.LeftMenu}>
                        <Menu menuItems={menu.tailormadeMenu.items} />
                    </nav>
                )}

                {/* Brides Collections Menu */}
                {menu.bridesMenu.hidden ? null : (
                    <nav className={classes.LeftMenu}>
                        <Menu menuItems={menu.bridesMenu.items} />
                    </nav>
                )}

                {/* BS Collections Menu */}
                {menu.bsMenu.hidden ? null : (
                    <nav className={classes.LeftMenu}>
                        <Menu menuItems={menu.bsMenu.items} />
                    </nav>
                )}

                <SideDrawer
                    open={showSideDrawer}
                    onClose={this.handleSideDrawerClose}
                />

                <div className={classes.ToggleMenu}>
                    <a href="" onClick={this.toggleSideDrawer}>
                        Menú
                    </a>
                </div>

                <main>{this.props.children}</main>

                <div className={classes.SocialNetworks}>
                    <SocialNetworks />
                </div>
            </Aux>
        );
    }
}

const mapStateToProps = state => {
    return {
        menu: state.menu
    };
};

const mapDispatchToProps = dispatch => {
    return bindActionCreators(menuActions, dispatch);
};

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(Layout);



// WEBPACK FOOTER //
// ./src/components/Layout/Layout.js